<template>
    <section class="border-y border-black/5 bg-white py-8" :id="id">
        <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
            <p class="mb-6 text-center text-xs font-bold uppercase tracking-[0.18em] text-text-muted">
                {{ t('trust.title') }}
            </p>

            <div class="marquee relative overflow-hidden" aria-hidden="true">
                <div class="marquee-track flex w-max items-center gap-12">
                    <span
                        v-for="(name, i) in loop"
                        :key="i"
                        class="flex shrink-0 items-center gap-2 text-lg font-bold tracking-tight text-text-main/55"
                    >
                        <span class="material-symbols-outlined text-[20px] text-primary">{{ icons[i % icons.length] }}</span>
                        {{ name }}
                    </span>
                </div>
                <div class="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent"></div>
                <div class="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent"></div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineProps<{ id?: string }>();

const { t } = useI18n();

const stack = ['Claude', 'OpenAI', 'Laravel', 'Vue', 'TypeScript', 'Python', 'AWS', 'PostgreSQL'];
const icons = ['auto_awesome', 'neurology', 'bolt', 'deployed_code', 'code', 'data_object', 'cloud', 'database'];
// Duplicate the list so the marquee loops seamlessly.
const loop = [...stack, ...stack];
</script>

<style scoped>
.marquee-track {
    animation: scroll-x 32s linear infinite;
}
@keyframes scroll-x {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
}
.marquee:hover .marquee-track { animation-play-state: paused; }
@media (prefers-reduced-motion: reduce) {
    .marquee-track { animation: none; flex-wrap: wrap; justify-content: center; }
}
</style>
